import { Controller } from "@hotwired/stimulus"
import { parseDate, stdDateParseFormat, stdDateDisplayFormat } from "../../helpers/date_helpers"
import { DateTime } from 'luxon'

// Connects to data-controller="configs--range"
export default class extends Controller {
  static targets = [
    'dateMinDisplay', 'dateMinField',
    'dateMaxDisplay', 'dateMaxField'
  ]

  static values = {
    dateMin: String,
    dateMax: String,
    mode: { type: String, default: 'display' },
    role: { type: String, default: 'follower' }
  }

  static classes = ['display', 'custom']

  connect() {
    app.configRanges ||= []
    app.configRanges.push(this)

    this.switchToMode()
  }

  dateMinValueChanged(val, previousVal) {
    if (val) {
      this.dateMinDisplayTarget.textContent = this.dateMinDisplay
      this.dateMinFieldTarget.value = val
    }
  }

  dateMaxValueChanged(val, previousVal) {
    if (val) {
      this.dateMaxDisplayTarget.textContent = this.dateMaxDisplay
      this.dateMaxFieldTarget.value = val
    }
  }

  modeValueChanged(val, prevVal) {
    this.switchToMode()
  }

  minFieldChanged(event) {
    if (event.target.validity.valid) {
      this.dateMinValue = this.dateMinFieldTarget.value
    }
  }

  maxFieldChanged(event) {
    if (event.target.validity.valid) {
      this.dateMaxValue = this.dateMaxFieldTarget.value
    }
  }

  // fieldChanged(event) {
  //   const name = event.params.extent
  //   console.log(name)

  //   if (event.target.validity.valid) {
  //     this[`date${name}Value`] = this[`date${name}FieldTarget`].value
  //   }
  // }

  switchToMode() {
    if (this.modeValue == 'custom') {
      this.element.classList.remove(...this.displayClasses)
      this.element.classList.add(...this.customClasses)
    } else {
      this.element.classList.remove(...this.customClasses)
      this.element.classList.add(...this.displayClasses)
    }
  }

  toggleMode() {
    if (this.modeValue == 'display') {
      this.modeValue = 'custom'
    } else {
      this.modeValue = 'display'
    }
  }

  get dateMin() {
    let dt = parseDate(this.dateMinValue)
    if (dt.invalid) { return DateTime.now().minus({ days: 30 }) }

    return dt
  }

  get dateMinStr() { return this.dateMin.toFormat(stdDateParseFormat) }
  get dateMinDisplay() { return this.dateMin.toFormat(stdDateDisplayFormat) }

  set dateMin(str) {
    let dt = parseDate(str)

    if (dt && dt.isValid) {
      this.dateMinValue = dt.toFormat(stdDateParseFormat)
    }
  }

  get dateMax() {
    let dt = parseDate(this.dateMaxValue)
    if (dt.invalid) { return DateTime.now() }

    return dt
  }

  get dateMaxStr() { return this.dateMax.toFormat(stdDateParseFormat) }
  get dateMaxDisplay() { return this.dateMax.toFormat(stdDateDisplayFormat) }

  set dateMax(str) {
    let dt = parseDate(str)
    this.dateMaxValue = dt.toFormat(stdDateParseFormat)
  }
}
